import React from 'react';
import { isProtected } from '~/util';

interface AttestationProtectionProps {
    riskGap: RiskGapType;
    submission?: null | PatientSubmissionType | undefined;
}

export function AttestationProtection({ riskGap, submission }: AttestationProtectionProps) {
    return (
        <div>
            {isProtected(riskGap, submission) ? (
                <button type="button" className="bookmark-document" title="Attestation Protected">
                    <i className="fa-solid fa-lg fa-shield-halved">
                        <span className="sr-only">Attestation Protected</span>
                    </i>
                </button>
            ) : (
                <span>&nbsp;</span>
            )}
        </div>
    );
}
